import { configFetch as fetch } from '@laigu/utils';

// 来鼓退出
export const logoutApi = (all_devices = null) => {
  const browser_id = `agent${new Date() * 1}`;
  return fetch({
    url: '/logout',
    method: 'POST',
    data: { all_devices, browser_id }
  });
};

// 检查登录状态
export const checkLoginStatusApi = () => {
  return fetch({
    url: '/agent/agents/has_logged_in',
    method: 'GET'
  });
};
